(function () {
  var sum = 0;
  var $btn = $('.donation__form [type="submit"]');
  function check_btn() {
    if (parseFloat(sum) > 0) {
      $btn.prop("disabled", false);
    } else {
      $btn.prop("disabled", true);
    }
  }
  $(".mmo-js-donation-radio").change(function (e) {
    $(".donation__other__sum").val("");
    sum = $(this).val();
    check_btn();
  });
  $(".mmo-js-donation-radio-other").change(function (e) {
    $btn.prop("disabled", true);
  });
  $(".donation__other__sum").on("textInput input change", function (e) {
    $(".mmo-js-donation-radio").prop("checked", false);
    $(".mmo-js-donation-radio-other").prop("checked", true);
    sum = $(this).val();
    check_btn();
  });
  $(".donation__form").submit(function (e) {
    e.preventDefault();
    $(this).find('[type="submit"]').prop("disabled", true);
    var url = $(this).data("url");
    var self = this;
    var $self = $(this);
    $.ajax(url, {
      dataType: "json",
      data: {
        action: "mmo_donation",
        sum: sum,
      },
      success: function (res) {
        if (res.success) {
          $self.append(res.inputs);
          self.submit();
        } else {
          $self.append(
            "<p style='margin: 15px 0; font-size: 18px; color: red;'><strong>Atsiprašome, įvyko klaida...</strong></p>"
          );
        }
      },
      error: function (err) {
        $self.append(
          "<p style='margin: 15px 0; font-size: 18px; color: red;'><strong>Atsiprašome, įvyko klaida...</strong></p>"
        );
      },
    });
  });
})();
